import { A9Service, AbstractDataProviderV2 } from 'components/system';

@A9Service('customerStackedRoundsMonthStatisticsDataProvider')
export class CustomerStackedRoundsMonthStatisticsDataProvider extends AbstractDataProviderV2 {
    constructor() {
        super();
        this.setApiUrl('middle://customers/statistics/stacked-rounds-played-month/{customerId}/{year}/{month}');
    }
}
